import { FunctionComponent } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Brands } from "@App/Pages/Common/Brands";
import { Generations } from "@App/Pages/Common/Generations";
import { Bodies } from "@App/Pages/Common/Bodies";
import { Motorizations } from "@App/Pages/Common/Motorizations";
import { Mileage } from "@App/Pages/Common/Mileage";
import { RegistrationDate } from "@App/Pages/Common/RegistrationDate";
import { Location } from "@App/Pages/Common/Location";
import { KeyNumber } from "@App/Pages/Common/KeyNumber";
import { useServiceFunnel } from "@App/hooks/useServiceFunnel";

/**
 * The funnel for the inspection service.
 *
 * @constructor
 */
export const Inspection: FunctionComponent = () => {
  const { navigateWithQuery } = useServiceFunnel("inspektion");

  return (
    <Routes>
      <Route
        path={"/"}
        element={
          <Brands
            headline={"Inspektion"}
            step={1}
            maxSteps={8}
            onKeyNumberLinkClick={() => navigateWithQuery("hsn-tsn")}
            onSubmit={() => navigateWithQuery(`modell`)}
          />
        }
      />
      <Route
        path={"/modell"}
        element={
          <Generations
            headline={"Inspektion"}
            step={2}
            maxSteps={8}
            onKeyNumberLinkClick={() => navigateWithQuery("hsn-tsn")}
            onSubmit={() => navigateWithQuery(`../motorisierung`, true)}
          />
        }
      />
      <Route
        path={"/motorisierung"}
        element={
          <Motorizations
            headline={"Inspektion"}
            step={3}
            maxSteps={8}
            onKeyNumberLinkClick={() => navigateWithQuery("hsn-tsn")}
            onSubmit={() => navigateWithQuery(`../bauart`, true)}
          />
        }
      />
      <Route
        path={"/hsn-tsn"}
        element={
          <KeyNumber
            headline={"Inspektion"}
            step={3}
            maxSteps={8}
            onVehicletreeLinkClick={() => navigateWithQuery("./")}
            onSubmit={() => navigateWithQuery(`../bauart`, true)}
          />
        }
      />
      <Route
        path={"/bauart"}
        element={
          <Bodies
            headline={"Inspektion"}
            step={4}
            maxSteps={8}
            onSubmit={() => navigateWithQuery(`../kilometerstand`, true)}
          />
        }
      />
      {/* Gearbox step ("/getriebe") deactivated: getVehicleEquipments-based flow is broken, see REP-3224 */}
      <Route
        path={"/kilometerstand"}
        element={
          <Mileage
            headline={"Inspektion"}
            step={5}
            maxSteps={8}
            onSubmit={() => navigateWithQuery(`../erstzulassung`, true)}
          />
        }
      />
      <Route
        path={"/erstzulassung"}
        element={
          <RegistrationDate
            headline={"Inspektion"}
            step={6}
            maxSteps={8}
            onSubmit={() => navigateWithQuery(`../ort`, true)}
          />
        }
      />
      {/* Equipment step ("/ausstattung") deactivated: getVehicleEquipments-based flow is broken, see REP-3224 */}
      <Route
        path={"/ort"}
        element={
          <Location
            headline={"Inspektion"}
            step={7}
            maxSteps={8}
            onSubmit={() => navigateWithQuery(`../werkstaetten`, true)}
          />
        }
      />
      {/* Redirect old links to funnel beginning */}
      <Route path={"/modellauswahl/*"} element={<Navigate to={"/inspektion"} />} />
    </Routes>
  );
};
